export const getAmountFormatter = (precision: number, locale = 'cs') =>
  new Intl.NumberFormat(locale, {
    signDisplay: 'never',
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  })
